import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

// ========|| Minimal Layout ||========

function FullScreenLayout() {
    return (
        <Box width="100%" height="100%">
            <Outlet />
        </Box>
    );
}

export default FullScreenLayout;
